import {
  FlightLogsEvent,
  EventType,
  EventSubtype
} from '../../common/api/spidertracks-sdk/types/FlightLogs';

interface FlightLeg {
  takeoff: FlightLogsEvent;
  landing: FlightLogsEvent | null;
}

export const getFlightLegs = (events: FlightLogsEvent[]): FlightLeg[] => {
  const legs: FlightLeg[] = [];
  const sortedEvents = [...events]
    .filter(
      event =>
        event.eventType === EventType.FLIGHT &&
        (event.eventSubtype === EventSubtype.Takeoff || event.eventSubtype === EventSubtype.Landing)
    )
    .sort((a, b) => a.eventTime - b.eventTime);

  let currentTakeoff: FlightLogsEvent | null = null;

  for (const event of sortedEvents) {
    if (event.eventSubtype === EventSubtype.Takeoff) {
      if (currentTakeoff) {
        console.log('found two consecutive takeoffs, skipping', event, currentTakeoff);
      }
      // Store the new takeoff
      currentTakeoff = event;
    } else if (event.eventSubtype === EventSubtype.Landing && currentTakeoff) {
      legs.push({
        takeoff: currentTakeoff,
        landing: event
      });
      currentTakeoff = null;
    }
  }

  // Handle any remaining takeoff without a landing
  if (currentTakeoff) {
    legs.push({
      takeoff: currentTakeoff,
      landing: null
    });
  }

  return legs;
};
